<template>
  <div v-if="isLatestFeatureUnlocked" id="latest-dashboard">
    <section v-if="layout === 'threecol'" :class="layout">
      <LatestArea :name="layouts[layout]['areas'][0]">
        <Headlines :draggable="enableDrag"></Headlines>
      </LatestArea>
      <LatestArea :name="layouts[layout]['areas'][1]">
        <FutureEventsCalendar :draggable="enableDrag"></FutureEventsCalendar>
      </LatestArea>
      <LatestArea :name="layouts[layout]['areas'][2]">
        <RiskRatingChanges :draggable="enableDrag"></RiskRatingChanges>
      </LatestArea>
      <LatestArea :name="layouts[layout]['areas'][3]">
        <PulseChanges :draggable="enableDrag"></PulseChanges>
      </LatestArea>
    </section>
  </div>
</template>

<script>
export default {
  name: "Latest",
  components: {
    FutureEventsCalendar: () =>
      import("@/components/futureEvents/FutureEventsCalendar"),
    Headlines: () => import("@/components/latest/Headlines"),
    LatestArea: () => import("@/components/latest/LatestArea"),
    RiskRatingChanges: () =>
      import("@/components/controlRisks/risks/RiskRatingChanges"),
    PulseChanges: () => import("@/components/grids/PulseChanges"),
  },
  data: () => ({
    enableDrag: false,
    //The currently used layout
    layout: "threecol",
    //The named areas of each layout
    /** @TODO: Extend layouts to assign components to layout areas for a user-customizable dashboard. */
    layouts: {
      threecol: {
        areas: ["A", "B0", "B1", "C"],
      },
    },
  }),
  computed: {
    isLatestFeatureUnlocked() {
      return this.featureUnlocked("latest-dashboard");
    },
  },
  methods: {},
};
</script>

<style scoped>
#latest-dashboard {
  width: calc(100vw - 245px);
  height: calc(100vh - 100px);
}
[draggable="true"] {
  cursor: grab;
}

/* "threecol Four" layout */
.threecol {
  max-height: 100%;
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: 50% 50%;
  grid-template-areas:
    "A B0 C"
    "A B1 C";
}
</style>
